import React from 'react';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue
} from './select';

/**
 * Liste déroulante conforme à la charte, en une ligne.
 *
 * Le module examens comptait dix `<select>` natifs : ils ne prennent ni la
 * hauteur `h-9`, ni le rayon `rounded-lg`, ni la couleur de focus du reste de
 * l'application, et leur menu est rendu par le système d'exploitation — donc
 * ni stylable, ni cohérent d'un poste à l'autre.
 *
 * `options` est une liste de `{ valeur, libelle }`. La valeur est convertie en
 * chaîne : Radix compare des chaînes, et un identifiant numérique passé tel
 * quel ne sélectionnerait jamais son élément.
 *
 * `groupes` est une liste de `{ libelle, options }` : une liste à en-têtes,
 * comme les mois rangés sous leur trimestre. Elle l'emporte sur `options`.
 * Une liste sans groupes se comporte exactement comme avant.
 */
const ChampSelect = ({
  valeur,
  onChange,
  options = [],
  groupes = null,
  placeholder = 'Sélectionner…',
  desactive = false,
  className = '',
  id
}) => (
  <Select
    value={valeur === null || valeur === undefined ? undefined : String(valeur)}
    onValueChange={onChange}
    disabled={desactive}
  >
    <SelectTrigger
      id={id}
      className={`h-9 rounded-lg border-gray-200 text-sm focus:border-[#246990] focus:ring-2 focus:ring-[#246990]/15 ${className}`}
    >
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      {Array.isArray(groupes) && groupes.length > 0
        ? groupes.map((groupe) => (
          <SelectGroup key={groupe.libelle}>
            <SelectLabel>{groupe.libelle}</SelectLabel>
            {groupe.options.map((option) => (
              <SelectItem key={String(option.valeur)} value={String(option.valeur)}>
                {option.libelle}
              </SelectItem>
            ))}
          </SelectGroup>
        ))
        : options.map((option) => (
          <SelectItem key={String(option.valeur)} value={String(option.valeur)}>
            {option.libelle}
          </SelectItem>
        ))}
    </SelectContent>
  </Select>
);

export default ChampSelect;
